<template>
    <div class="form-container">
      <form-container-header v-if="title" :title="title"></form-container-header>
      <slot></slot>
    </div>
</template>
<script>
    import FormContainerHeader from '@/components/FormContainerHeader.vue'
    export default {
        props: {
            title: { required: false }
        },
        components: {
            FormContainerHeader
        }
    }
</script>